import { ActionButtonProps } from '../components/ActionButton'
import { DeclarationItemType } from '../graphql/generated/graphql'

export type Image = {
  src: string
  alt: string
}

export enum DeclarationType {
  Participation = 'Participation',
  Fonction = 'Fonction',
  Mandat = 'Mandat',
  Entreprise = 'Entreprise étrangère',
}

export enum DeclarationItemState {
  Validated = 'valid',
  Pending = 'pending',
  Refused = 'refused',
}

export type FullDeclaration = {
  id: number
  type: DeclarationItemType
  companyJob: string
  siren?: string
  rnaSiren?: string
  companyName?: string
  entity?: string
  address?: string
  city?: string
  postalCode?: string
}

export type SimpleDeclaration = {
  id: number
  description: string
  state: DeclarationItemState
}

export type StepProps = {
  [x: string]: any
  t: any
  dispatch: any
  formValues: any
}

export type Member = 'registrant' | 'partner' | 'child'

export type MemberProps = StepProps & {
  fullName: string
}

export type MemberReturn = {
  declarations: FullDeclaration[]
  addDeclaration: (values: any) => void
  updateDeclaration: (i: number, values: any) => void
  deleteDeclaration: (i: number) => void
  addMember: (values: any) => void
  resetMember: () => void
  addMemberInitialValues: {
    hasMemberToDeclare: string
    civility: string
    firstName: string
    lastName: string
    familyRelationshipId?: string
    familyRelationshipCustom?: string
  }
  addAnotherChild: ActionButtonProps
  addDeclarationStepPartText: string
  addDeclarationLabel: string
  declarationListStepPartText: string
  declarationListLabel: string
  addMemberStepPartText: string
  addMemberLabel: string
  typeOfAdd: 'registrant' | 'partner' | 'child'
}

export type Partner = {
  civility: string
  firstName: string
  lastName: string
  familyRelationshipId?: string | null
  familyRelationshipCustom?: string | null
  items?: FullDeclaration[]
}

export type Child = Partner

export type Registrant = Partner

export type FormValues = {
  terms: boolean
  cciFunction: string
  intent: string
  items: FullDeclaration[]
  partner?: Partner
  children?: Child[]
}

export const NUMBER_OF_CHILDREN = 10
